import { Icon, Label } from "semantic-ui-react";

import { isDealerInvoicingEnabled, isLocationInvoicingEnabled } from "modules/DealersDashboard/components/DealersDashboardTable/components/DealerLocationsTable";

import type { Dealer, DealerLocation } from "models";

type DealerInvoicingCellProps = {
  dealer: Dealer;
};

const getActiveLocations = (locations?: DealerLocation[]) => locations?.filter(location => location.active) ?? [];
const countMissingExactLicenses = (locations?: DealerLocation[]) =>
  locations?.reduce((count, location) => count + (location.number_of_missing_exact_licenses ?? 0), 0) ?? 0;

export const DealerInvoicingCell = ({ dealer }: DealerInvoicingCellProps) => {
  const activeLocations = getActiveLocations(dealer.locations);
  const missingExactLicenses = countMissingExactLicenses(dealer.locations);

  const isEnabled =
    isDealerInvoicingEnabled(dealer) || (!!activeLocations.length && activeLocations.every(location => location.is_exact_invoicing_enabled && location.exact_account_id));

  const invoicingEnabledLocations = activeLocations.filter(location => isLocationInvoicingEnabled(location, dealer)).length;

  return (
    <div className="invoicing-container">
      <Icon className={isEnabled ? "check circle" : "circle xmark"} color={isEnabled ? "green" : "red"} />
      <span className="no-wrap-text">{`${invoicingEnabledLocations}/${activeLocations.length}`}</span>
      {missingExactLicenses > 0 && (
        <Label circular color="red">
          {missingExactLicenses}
        </Label>
      )}
    </div>
  );
};
